import { useMemo } from "react";
import Highcharts from "highcharts";
import { Chart } from "@highcharts/react";
import exporting from "highcharts/modules/exporting";
import exportData from "highcharts/modules/export-data";
import offlineExporting from "highcharts/modules/offline-exporting";
import { lineChartData, LineChartDataPoint } from "../mockData";
import "../style.css";
import { timelineItemClasses } from "@mui/lab";
import {
  SeriesOptionsType,
  XAxisOptions,
  YAxisOptions,
} from "highcharts/highcharts.src";

// if (typeof Highcharts === 'object') {
//     if (typeof window !== 'undefined' && (window as any).Highcharts?.modules?.exporting) {
//     } else {
//         exporting(Highcharts)
//         offlineExporting(Highcharts)
//         exportData(Highcharts)
//     }
// }

type TProps = {
  title?: string;
  series: SeriesOptionsType[];
  xAxis: XAxisOptions | XAxisOptions[];
  yAxis: YAxisOptions | YAxisOptions[];
  data?: LineChartDataPoint[];
};

export function LineChart(props: TProps) {
  const { data, title, series, xAxis, yAxis } = props;
  const chartOptions = useMemo(() => {
    return {
      chart: {
        type: "line",
        height: null,
        width: null,
      },
      title: {
        text: title,
      },
      xAxis: xAxis,
      // xAxis: {
      //     categories: years.map((y) => y.toString()),
      //     title: {
      //         text: 'Year',
      //     },
      // },
      yAxis: yAxis,
      // yAxis: {
      //     title: {
      //         text: 'Value',
      //     },
      // },
      legend: {
        enabled: true,
      },
      tooltip: {
        shared: true,
        useHTML: true,
        // formatter: function (this: Highcharts.TooltipFormatterContextObject) {
        //     let tooltip = `<b>${this.x}</b><br/>`
        //     this.points?.forEach((point) => {
        //         tooltip += `<span style="color:${point.color}">●</span> ${point.series.name}: <b>${point.y}</b><br/>`
        //     })
        //     return tooltip
        // },
      },
      plotOptions: {
        line: {
          dataLabels: {
            enabled: true,
          },
          enableMouseTracking: true,
        },
      },
      series: series,
      credits: {
        enabled: false,
      },
      exporting: {
        enabled: true,
        showTable: false,
        buttons: {
          contextButton: {
            menuItems: [
              "printChart",
              "separator",
              "downloadPNG",
              "downloadJPEG",
              "downloadPDF",
              "downloadSVG",
              "separator",
              "downloadCSV",
              "downloadXLS",
              "separator",
              "viewData",
            ],
          },
        },
      },
      // responsive: {
      //   rules: [
      //     {
      //       condition: {
      //         maxWidth: 500,
      //       },
      //       chartOptions: {
      //         legend: {
      //           layout: "horizontal",
      //           align: "center",
      //           verticalAlign: "bottom",
      //         },
      //       },
      //     },
      //   ],
      // },
    };
  }, [series]);

  return (
    <div className="chart-wrapper">
      {/*<Chart highcharts={Highcharts} options={chartOptions} />*/}
      <Chart options={chartOptions} />
    </div>
  );
}
